__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/57bc59b/_next/";